// StudentProfile.jsx
import React, { useState } from "react";
import { FaRupeeSign } from "react-icons/fa";
import "./student.css";

const StudentProfile = () => {
  const [user] = useState(JSON.parse(localStorage.getItem("student")));
  const [showForm, setShowForm] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [submitting, setSubmitting] = useState(false); // Added loading state
  const [referralData, setReferralData] = useState({
    UID: user.student.UID,
    name: "",
    referralName: "",
    referralNumber: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setReferralData({ ...referralData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true); // Start loading

    try {
      const response = await fetch(`${process.env.REACT_APP_REFERRAL}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(referralData),
      });

      const result = await response.json();
      if (result.success) {
        setReferralData({
          name: "",
          referralName: "",
          referralNumber: "",
        });
        setShowForm(false);
        setShowPopup(true);
        alert("Referral form submitted successfully!");
      } else {
        alert("Failed to submit form. Please try again!");
      }
    } catch (error) {
      alert("Error submitting form: " + error.message);
    } finally {
      setSubmitting(false); // Stop loading regardless of success/error
      setTimeout(() => setShowPopup(false), 2000);
    }
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setReferralData({
      name: "",
      referralName: "",
      referralNumber: "",
    });
  };

  function formatDate(dateStr) {
    const [year, month, day] = dateStr.split("-").map(Number);
    const date = new Date(year, month - 1, day);

    const formatted = date.toLocaleString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });

    return formatted;
  }

  return (
    <div className="student-profile-container">
      <div className="profile-section pro-card">
        <div className="profile-glow"></div>
        <img src={user.profileImage} alt="Student" className="student-image" />
        <h2 className="student-name">👋Hello, {user.student.studentName}!</h2>
        <p>{user.student.email}</p>

        <p className="program-tag">
          🚀 Enrolled in:{" "}
          {user.student.program === "tech-pro" ? (
            <strong>Tech Pro</strong>
          ) : (
            <strong>Tech Smart</strong>
          )}
        </p>
        <p>Registered on: {formatDate(user.student.joinedDate)}</p>
      </div>

      <div className="referral-section pro-card">
        <div className="glow-effect"></div>
        <div className="section-header">
          <h3 className="refer-section-title">
            🎁 Refer & Earn <FaRupeeSign className="rupee-ico" />
            {user.student.program === "tech-pro" ? (
              <span>1000/-</span>
            ) : (
              <span> 500/-</span>
            )}
          </h3>

          {showForm && (
            <button className="close-form-btn" onClick={handleCloseForm}>
              ×
            </button>
          )}
        </div>

        {!showForm ? (
          <button className="refer-btn" onClick={() => setShowForm(true)}>
            Refer & Earn
          </button>
        ) : (
          <form className="referral-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={referralData.name}
              onChange={handleChange}
              required
              disabled={submitting} // Disable inputs while submitting
            />
            <input
              type="tel"
              name="number"
              placeholder="Your Contact Number"
              value={referralData.number}
              onChange={handleChange}
              required
              disabled={submitting}
            />
            <input
              type="text"
              name="referralName"
              placeholder="Referral Name"
              value={referralData.referralName}
              onChange={handleChange}
              required
              disabled={submitting}
            />
            <input
              type="tel"
              name="referralNumber"
              placeholder="Referral Contact Number"
              value={referralData.referralNumber}
              onChange={handleChange}
              required
              disabled={submitting}
            />
            <div className="form-actions">
              <button
                type="button"
                className="cancel-btn"
                onClick={handleCloseForm}
                disabled={submitting} // Disable cancel while submitting
              >
                Cancel
              </button>
              <button
                type="submit"
                className={`submit-referral ${submitting ? "submitting" : ""}`}
                disabled={submitting}
              >
                {submitting ? (
                  <>
                    <span className="spinner"></span>
                    Submitting...
                  </>
                ) : (
                  "Submit Referral"
                )}
              </button>
            </div>
          </form>
        )}

        {/* {showPopup && <div className="popup-success">🎉 Request Received!</div>} */}
      </div>

      <div className="placement-section">
        <h3>Placement Assistance</h3>
        <p>Coming Soon...</p>
      </div>
    </div>
  );
};

export default StudentProfile;
